import { getDatev2 } from '@/libs/utils/times';
import { getUserData } from '@/libs/utils/user';

export function setFormatMsg(msg, active_chat, previous_message_date = null) {
  const sender = active_chat.brand.id === msg.sender_id ? active_chat.brand : active_chat.creator;
  const obj = {
    uuid: msg.uuid,
    sender,
    message: msg.type_message === 'text' || msg.type_message === 'automated' || msg.type_message === 'revision' ? msg.message : msg.link,
    type_message: msg.type_message,
    sended_at: msg.sended_at,
    sender_id: msg.sender_id,
    file: msg.type_message === 'file' || msg.type_message === 'content' ? msg.file : '',
    is_same_date: previous_message_date !== getDatev2(new Date(msg.sended_at)),
    seen: msg.seen,
    text_publish: msg.text,
    chat_deals: msg.chat_deal,
    show_btns: false,
    type_action: msg.type_action,
    show_btns_links: false,
    deal_custom: msg.type_message === 'deal' ? msg : null,
  }

  return obj
}

export function shouldIncludeMessage(msg, receiver_id, active_chat) {
  if (msg.type_message !== 'automated' || msg.variant_automated === 'bot') return true
  if (msg.variant_automated === 'buyer' && active_chat.brand.id === receiver_id) return true
  if (msg.variant_automated === 'seller' && active_chat.creator.id === receiver_id) return true

  return false
}

export function formatMessages(active_chat) {
  const receiver = getUserData();
  let previous_message_date = null

  return active_chat.messages.reduce((result, msg) => {
    if (!shouldIncludeMessage(msg, receiver.id, active_chat)) return result

    result.push(setFormatMsg(msg, active_chat, previous_message_date))
    previous_message_date = getDatev2(new Date(msg.sended_at))

    return result
  }, [])
}